import BaseService from '../../base/base_service';
import _ from '../../utils/underscore';
import IOpenSessions, {OpenSessionsServiceInitParams} from './open_sessions_service_interface';

class OpenSessionsService extends BaseService implements IOpenSessions{

  static CLASS: string = 'OpenSessionsService';
  private _initParams: OpenSessionsServiceInitParams = null;

  init(params: OpenSessionsServiceInitParams) {
    super.init(params);
    this._setInitParams(params);
  }

  private _setInitParams(params: OpenSessionsServiceInitParams): void {
    this._initParams = {
      uri: params.uri
    };
  }

  public getPlayerOpenSessionsBalance(): Promise<number> {
    return this.getPlayerRealMoneyOpenSessions().then((openSessions)=> {
      let sum = 0;
      for(let index=0, openSessionsLength = openSessions.length; index < openSessionsLength; index++) {
        const credit = openSessions[index].Credit;
        if(!_.isNullOrUndefined(credit)){
          sum += Number(credit);
        }
      }

      return sum;
    });
  }

  public getPlayerRealMoneyOpenSessions(): Promise<any> {
    const uri = this._initParams.uri + '/getOpenSessions';
    return this.serviceFactory.http2Service().post(uri, {
      includeFreePlaySessions: false
    })
      .then(data => (data as any).sessionDetails);
  }
}

export default OpenSessionsService;